import api from "./Api";
import TokenService from "./TokenService";

class AuthService {
  login(payload) {
    return api.post("/v1/auth/login/", payload).then((response) => {
      if (response.data.Data.Token) {
        TokenService.setUser(response.data.Data);
        TokenService.setLogin(
          payload.Login,
          payload.Password,
          payload.LembrarMe
        );
      }
      return response.data.Data;
    });
  }

  logout() {
    TokenService.removeUser();
  }

  RevokeSession(payload) {
    const encodedToken = encodeURIComponent(payload);
    return api
      .post("/v1/auth/revoke-session/" + encodedToken)
      .then((response) => {
        return response.data;
      });
  }

  RevokeSessionId(payload) {
    return api
      .post("/v1/auth/revoke-session-id/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  RefreshTokenEmpresa(payload) {
    return api
      .post("/v1/auth/RefreshTokenEmpresa/", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new AuthService();
